'use client'
import { Paragraph, Section } from '@dynamo-caffeina-dev/airc-ui-kit'

import { NormalizedSection, ParagraphProps } from '@/types'

export interface ParagraphSectionProps extends NormalizedSection {
  modelledContent: {
    paragraph: ParagraphProps
  }
}
const ParagraphSection = ({ modelledContent }: ParagraphSectionProps) => {
  const { paragraph } = modelledContent
  return (
    <Section className='section-paragraph'>
      <div className='section-paragraph__content'>
        <Paragraph
          // NOTE
          // The default value is 'center'; text is typically left-aligned,
          // so we set it to 'left' directly in the FE via the `alignment` prop.
          //
          // This is necessary because otherwise the user, while trying to align
          // the text to the left in the CMS editor, would see no changes applied
          // in the FE.
          //
          // This happens because the editor does not align -- i.e. does not output
          // inline CSS -- to the left (which it considers a default), but only
          // to the center and right.
          //
          // So, text in the FE will be left-aligned by default, but the user
          // can always override this by setting the text to 'center' or 'right'
          // in the CMS editor. Then inline styles will take precedence over the
          // default component value.
          //
          // Ref: https://neversleep.atlassian.net/browse/AW-1208
          alignment={'left'}
          as='div'
          variant={paragraph.variant}
          dangerouslySetInnerHTML={{ __html: paragraph.content || '' }}
        />
      </div>
    </Section>
  )
}

export default ParagraphSection
